<!-- Sample data banner at the very top, full width -->
<app-sample-data-banner *ngIf="isOpenOrShow && !suppressTrialUx"></app-sample-data-banner>

<div *ngIf="suppressTrialUx && isOpenOrShow && activeDemoPersona" class="demo-realm-banner">
  <span class="material-symbols-outlined">business</span>
  <span>Demo: <strong>{{ activeDemoPersona.name }}</strong> · {{ activeDemoPersona.seededEmployeeCount }}
    employees</span>
  <a routerLink="/demo-console">Switch company</a>
</div>

<mat-drawer-container class="example-container" [class.has-top-banner]="isShowingDemoData" autosize id="screenshotArea">

  <mat-drawer #drawerInstance *ngIf="isOpenOrShow" [opened]="sideMenu" [mode]="sideMenuMode"
    [disableClose]="isDesktopView" [class.sidebar-interacting]="sidebarInteracting"
    [class.desktop-collapsed]="isDesktopCollapsedMode()" (openedChange)="onDrawerToggle($event)">
    <div class="sidenav-main-div">
      <div class="row sidebar-header-row">
        <div class="col s12 sidebar-header-content" [routerLink]="['/dashboard']" style="cursor: pointer;">
          <h2>
            <ng-container *ngIf="isDesktopCollapsedMode(); else expandedBrand">
              <img src="assets/images/SuperSee_icon_colored.webp" alt="SuperSee" class="sidebar-logo" />
            </ng-container>
            <ng-template #expandedBrand>
              <img src="assets/images/SuperSee_horizontal_white_text_transparent_bg.webp" alt="SuperSee"
                class="sidebar-lockup" />
            </ng-template>
          </h2>
        </div>
      </div>
      <div class="nav-div" (mouseenter)="setSidebarInteracting(true)" (mouseleave)="setSidebarInteracting(false)">

        <div class="row nav-row {{ checkIsActive('/dashboard') }}" [routerLink]="['/dashboard']"
          [matTooltip]="'Dashboard'" [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Dashboard' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> dashboard </span>
              <span *ngIf="!isDesktopCollapsedMode()">Dashboard</span>
            </h3>
          </div>
        </div>
        <div *ngIf="suppressTrialUx" class="row nav-row {{ checkIsActive('/demo-console') }}"
          [routerLink]="['/demo-console']" matTooltip="Demo Console" [matTooltipDisabled]="!isDesktopCollapsedMode()"
          matTooltipPosition="right">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> preview </span>
              <span *ngIf="!isDesktopCollapsedMode()">Demo Console</span>
            </h3>
          </div>
        </div>
        <div class="row nav-row {{ checkIsActive('/employees') }}" [routerLink]="['/employees']"
          [matTooltip]="'Employees'" [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Employees' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> person </span>
              <span *ngIf="!isDesktopCollapsedMode()">Employees</span>
            </h3>
          </div>
        </div>

        <div *ngIf="showLiveMonitoringNav()" class="row nav-row {{ checkIsActive('/live-monitoring') }}"
          [class.nav-row--locked]="isLiveMonitoringNavLocked()"
          [routerLink]="isLiveMonitoringNavLocked() ? null : ['/live-monitoring']"
          (click)="onEntitlementNavClick($event, entitlementKeys.live_screencast)"
          [matTooltip]="isLiveMonitoringNavLocked() ? lockedNavTooltip(entitlementKeys.live_screencast) : 'Live Monitoring'"
          [matTooltipDisabled]="!isDesktopCollapsedMode() && !isLiveMonitoringNavLocked()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Live Monitoring' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> videocam </span>
              <span *ngIf="!isDesktopCollapsedMode()">Live Monitoring</span>
              <span *ngIf="!isDesktopCollapsedMode() && isLiveMonitoringNavLocked()"
                class="nav-lock-icon material-symbols-outlined">lock</span>
            </h3>
          </div>
        </div>

        <div class="row nav-row {{ checkIsActive('/screenshots') }}" [routerLink]="['/screenshots']"
          [matTooltip]="'Screenshots'" [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Screenshots' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> photo_camera </span>
              <span *ngIf="!isDesktopCollapsedMode()">Screenshots</span>
            </h3>
          </div>
        </div>

        <div *ngIf="showWorkReplayNav()" class="row nav-row {{ checkIsActive('/work-replay') }}"
          [class.nav-row--locked]="isWorkReplayNavLocked()"
          [routerLink]="isWorkReplayNavLocked() ? null : ['/work-replay']" (click)="onWorkReplayNavClick($event)"
          [matTooltip]="isWorkReplayNavLocked() ? lockedNavTooltip(entitlementKeys.work_replay) : 'Work Replay'"
          [matTooltipDisabled]="!isDesktopCollapsedMode() && !isWorkReplayNavLocked()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Work Replay' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> movie </span>
              <span *ngIf="!isDesktopCollapsedMode()">Work Replay</span>
              <span *ngIf="!isDesktopCollapsedMode() && isWorkReplayNavLocked()"
                class="nav-lock-icon material-symbols-outlined">lock</span>
            </h3>
          </div>
        </div>

        <div class="row nav-row {{ checkIsActive('/projects') }}" (click)="moveTeamList()" [matTooltip]="'Teams'"
          [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Teams' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> groups </span>
              <span *ngIf="!isDesktopCollapsedMode()">Teams</span>
            </h3>
          </div>
        </div>

        <div class="row nav-row menu-parent" [class.active-nav]="isReportsRouteActive()"
          [matMenuTriggerFor]="isDesktopCollapsedMode() ? reportsFlyoutMenu : null"
          (click)="onReportsInteraction($event)" [matTooltip]="'Reports'"
          [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Reports' : null">
          <div class="col s12">
            <h3>
              <span class="material-symbols-outlined">bar_chart</span>
              <span *ngIf="!isDesktopCollapsedMode()">Reports</span>
              <span *ngIf="!isDesktopCollapsedMode()" class="material-symbols-outlined expand-icon"
                [class.expanded]="expandedMenus['reports']">
                expand_more
              </span>
            </h3>
          </div>
        </div>

        <div class="submenu-container" [class.open]="expandedMenus['reports'] && !isDesktopCollapsedMode()">
          <div class="row nav-row submenu-item {{ checkIsActive('/user-report') }}" [routerLink]="['/user-report']">
            <div class="col s12" (click)="checkSideMenu()">
              <h4>
                <span class="material-symbols-outlined submenu-icon">
                  summarize
                </span>
                <span class="submenu-label">Timesheet</span>
              </h4>
            </div>
          </div>
          <div *ngIf="showWebsiteUsageNav()" class="row nav-row submenu-item {{ checkIsActive('/reports') }}"
            [class.nav-row--locked]="isNavEntitlementLocked(entitlementKeys.website_usage)"
            [routerLink]="isNavEntitlementLocked(entitlementKeys.website_usage) ? null : ['/reports']"
            (click)="onEntitlementNavClick($event, entitlementKeys.website_usage)">
            <div class="col s12" (click)="checkSideMenu()">
              <h4>
                <span class="material-symbols-outlined submenu-icon">assessment</span>
                <span class="submenu-label">App &amp; Website Usage</span>
                <span *ngIf="isNavEntitlementLocked(entitlementKeys.website_usage)"
                  class="nav-lock-icon material-symbols-outlined">lock</span>
              </h4>
            </div>
          </div>
          <div *ngIf="showProductivityTrendsNav()"
            class="row nav-row submenu-item {{ checkIsActive('/productivity-trends') }}"
            [class.nav-row--locked]="isProductivityTrendsNavLocked()"
            [routerLink]="isProductivityTrendsNavLocked() ? null : ['/productivity-trends']"
            (click)="onProductivityTrendsNavClick($event)">
            <div class="col s12" (click)="checkSideMenu()">
              <h4>
                <span class="material-symbols-outlined submenu-icon">timeline</span>
                <span class="submenu-label">Productivity Trends</span>
                <span *ngIf="isProductivityTrendsNavLocked()"
                  class="nav-lock-icon material-symbols-outlined">lock</span>
              </h4>
            </div>
          </div>
        </div>

        <div *ngIf="isAdmin && showDataManagementNav()"
          class="row nav-row nav-row--section-start {{ checkIsActive('/data-management') }}"
          [routerLink]="['/data-management']" matTooltip="Data Management"
          [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Data Management' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined">home_storage_gear</span>
              <span *ngIf="!isDesktopCollapsedMode()">Data Management</span>
            </h3>
          </div>
        </div>

        <div *ngIf="isAdmin && showDeviceManagementNav()" class="row nav-row {{ checkIsActive('/device-management') }}"
          [class.nav-row--locked]="isNavEntitlementLocked(entitlementKeys.device_management)"
          [routerLink]="isNavEntitlementLocked(entitlementKeys.device_management) ? null : ['/device-management']"
          (click)="onEntitlementNavClick($event, entitlementKeys.device_management)"
          [matTooltip]="isNavEntitlementLocked(entitlementKeys.device_management) ? lockedNavTooltip(entitlementKeys.device_management) : 'Devices'"
          [matTooltipDisabled]="!isDesktopCollapsedMode() && !isNavEntitlementLocked(entitlementKeys.device_management)"
          matTooltipPosition="right" [attr.aria-label]="isDesktopCollapsedMode() ? 'Devices' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> devices </span>
              <span *ngIf="!isDesktopCollapsedMode()">Devices</span>
              <span *ngIf="!isDesktopCollapsedMode() && isNavEntitlementLocked(entitlementKeys.device_management)"
                class="nav-lock-icon material-symbols-outlined">lock</span>
            </h3>
          </div>
        </div>

        <div *ngIf="isAdmin && showAuditLogsNav()" class="row nav-row {{ checkIsActive('/audit-logs') }}"
          [class.nav-row--section-start]="!showDataManagementNav()"
          [class.nav-row--locked]="isNavEntitlementLocked(entitlementKeys.live_wall)"
          [routerLink]="isNavEntitlementLocked(entitlementKeys.live_wall) ? null : ['/audit-logs']"
          (click)="onEntitlementNavClick($event, entitlementKeys.live_wall)"
          [matTooltip]="isNavEntitlementLocked(entitlementKeys.live_wall) ? lockedNavTooltip(entitlementKeys.live_wall) : 'Audit Logs'"
          [matTooltipDisabled]="!isDesktopCollapsedMode() && !isNavEntitlementLocked(entitlementKeys.live_wall)"
          matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Audit Logs' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> manage_history </span>
              <span *ngIf="!isDesktopCollapsedMode()">Audit Logs</span>
              <span *ngIf="!isDesktopCollapsedMode() && isNavEntitlementLocked(entitlementKeys.live_wall)"
                class="nav-lock-icon material-symbols-outlined">lock</span>
            </h3>
          </div>
        </div>

        <div *ngIf="isAdmin || isUserManager" class="row nav-row {{ checkIsActive('/employee/setting') }}"
          [routerLink]="['/employee/setting']" [matTooltip]="'Settings'"
          [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Settings' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined"> tune </span>
              <span *ngIf="!isDesktopCollapsedMode()">Settings</span>
            </h3>
          </div>
        </div>

        <div class="row nav-row nav-row--section-start {{ checkIsActive('/help-support') }}"
          [routerLink]="['/help-support']" [matTooltip]="'Help & Support'"
          [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right"
          [attr.aria-label]="isDesktopCollapsedMode() ? 'Help & Support' : null">
          <div class="col s12" (click)="checkSideMenu()">
            <h3>
              <span class="material-symbols-outlined">
                help
              </span>
              <span *ngIf="!isDesktopCollapsedMode()">Help &amp; Support</span>
            </h3>
          </div>
        </div>
      </div>

    </div>

    <div class="sidebar-footer-actions" (mouseenter)="setSidebarInteracting(true)"
      (mouseleave)="setSidebarInteracting(false)">
      <!-- @if (isShowRenewPlan) {
      <div *ngIf="isAdmin" class="row nav-row upgradeNowButton {{ checkIsActive('/employee/setting') }}"
        [routerLink]="['/billings']" [matTooltip]="'Billing'" [matTooltipDisabled]="!isDesktopCollapsedMode()"
        matTooltipPosition="right" [attr.aria-label]="isDesktopCollapsedMode() ? 'Billing' : null">
        <div class="col s12" (click)="checkSideMenu()">
          @if (quotaStatus == 'trial' || quotaStatus == 'trial-expired' || quotaStatus == 'Trial-expired' ||
          quotaStatus == 'Trial') {
          <h3><span class="material-symbols-outlined">shopping_cart</span><span
              *ngIf="!isDesktopCollapsedMode()">Buy</span></h3>
          } @else if (quotaStatus == 'active' || quotaStatus == 'Active') {
          <h3><span class="material-symbols-outlined">restart_alt</span><span
              *ngIf="!isDesktopCollapsedMode()">Renew</span></h3>
          } @else if (quotaStatus == 'expired' || quotaStatus == 'Expired') {
          <h3><span class="material-symbols-outlined">restart_alt</span><span
              *ngIf="!isDesktopCollapsedMode()">Upgrade</span></h3>
          }
        </div>
      </div>
      } -->

      @if (isShowRenewPlan) {
      <a *ngIf="isAdmin" href="/billings" class="row nav-row upgradeNowButton"
        [matTooltip]="'Billing'" [matTooltipDisabled]="!isDesktopCollapsedMode()"
        matTooltipPosition="right" [attr.aria-label]="isDesktopCollapsedMode() ? 'Billing' : null">
        <div class="col s12" (click)="checkSideMenu()">
          @if (quotaStatus == 'trial' || quotaStatus == 'trial-expired' || quotaStatus == 'Trial-expired' ||
          quotaStatus == 'Trial') {
          <h3><span class="material-symbols-outlined">shopping_cart</span><span
              *ngIf="!isDesktopCollapsedMode()">Buy</span></h3>
          } @else if (quotaStatus == 'active' || quotaStatus == 'Active') {
          <h3><span class="material-symbols-outlined">restart_alt</span><span
              *ngIf="!isDesktopCollapsedMode()">Renew</span></h3>
          } @else if (quotaStatus == 'expired' || quotaStatus == 'Expired') {
          <h3><span class="material-symbols-outlined">restart_alt</span><span
              *ngIf="!isDesktopCollapsedMode()">Upgrade</span></h3>
          }
        </div>
      </a>
      }

      <button *ngIf="isDesktopView" type="button" class="sidebar-collapse-btn"
        [class.is-collapsed]="desktopSidebarCollapsed" (click)="toggleDesktopSidebar()"
        [attr.aria-label]="desktopSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        [matTooltip]="desktopSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        [matTooltipDisabled]="!isDesktopCollapsedMode()" matTooltipPosition="right">
        <span class="material-symbols-outlined sidebar-collapse-icon">
          {{ desktopSidebarCollapsed ? 'last_page' : 'first_page' }}
        </span>
        <span *ngIf="!isDesktopCollapsedMode()" class="sidebar-collapse-label">
          {{ desktopSidebarCollapsed ? 'Expand' : 'Collapse' }}
        </span>
      </button>
    </div>

    <mat-menu #reportsFlyoutMenu="matMenu" xPosition="after" yPosition="below" class="sidebar-flyout-menu">
      <button mat-menu-item [routerLink]="['/user-report']" (click)="checkSideMenu()"
        [class.active-flyout-item]="!!checkIsActive('/user-report')">
        <span class="material-symbols-outlined">summarize</span>
        <span>Timesheet</span>
      </button>
      <button *ngIf="showWebsiteUsageNav()" mat-menu-item
        [class.flyout-item-locked]="isNavEntitlementLocked(entitlementKeys.website_usage)"
        [class.active-flyout-item]="!!checkIsActive('/reports')"
        [routerLink]="isNavEntitlementLocked(entitlementKeys.website_usage) ? null : ['/reports']"
        (click)="onFlyoutEntitlementClick($event, entitlementKeys.website_usage)">
        <span class="material-symbols-outlined">assessment</span>
        <span>App &amp; Website Usage</span>
        <span *ngIf="isNavEntitlementLocked(entitlementKeys.website_usage)"
          class="flyout-lock-icon material-symbols-outlined">lock</span>
      </button>
      <button *ngIf="showProductivityTrendsNav()" mat-menu-item
        [class.flyout-item-locked]="isProductivityTrendsNavLocked()"
        [class.active-flyout-item]="!!checkIsActive('/productivity-trends')"
        [routerLink]="isProductivityTrendsNavLocked() ? null : ['/productivity-trends']"
        (click)="onProductivityTrendsFlyoutClick($event)">
        <span class="material-symbols-outlined">timeline</span>
        <span>Productivity Trends</span>
        <span *ngIf="isProductivityTrendsNavLocked()" class="flyout-lock-icon material-symbols-outlined">lock</span>
      </button>
    </mat-menu>
  </mat-drawer>

  <mat-drawer #componentDrawerInstance mode="over"
    [style.width]="'min(' + (componentDrawerWidth || 620) + 'px, 100vw)'"
    [style.max-width]="'100vw'" class="component-load-drawer"
    position="end" [style.background]="'white !important'"
    (closed)="onComponentDrawerClosed()">
    <ng-template #componentReferer></ng-template>
  </mat-drawer>

  <mat-drawer-content>
    <app-header *ngIf="isOpenOrShow"></app-header>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>

<!-- <a *ngIf="showWhatsAppButton" [href]="whatsappUrl" class="whatsapp-floating-button" target="_blank" rel="noopener">
  <mat-icon svgIcon="whatsapp" aria-hidden="false" aria-label="Chat on WhatsApp"></mat-icon>
  <span class="support-text">Talk to Support?</span>
</a> -->

<div class="">
  <tour-step-template>
    <ng-template let-step="step">
      <mat-card class="ui-tour-card" (click)="$event.stopPropagation()" [style.width]="step.stepDimensions?.width"
        [style.min-width]="step.stepDimensions?.minWidth" [style.max-width]="step.stepDimensions?.maxWidth">
        <div class="Tourheader row">
          <div class="col s9">
            <mat-card-title class="tourHeaderTitle">
              {{step.title}}
            </mat-card-title>
          </div>

          <div class="col s3 close-btn-contain">
            <button mat-icon-button (click)="tourClose()" class="close TourheaderButton">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div class="row step-content">
          <div class="col s12">
            <p [innerHTML]="step.content"></p>
          </div>
        </div>
        <div class="row tour-btn-container">
          <div class="col s12 tour-btn-contain">
            <button mat-button class="prev" [disabled]="!tourService.hasPrev(step)" (click)="previousAction(step)">
              <mat-icon>chevron_left</mat-icon>
              {{step.prevBtnTitle}}
            </button>
            <button class="next" *ngIf="tourService.hasNext(step) && !step.nextOnAnchorClick"
              (click)="tourService.next()" mat-button>
              {{step.nextBtnTitle}}
              <mat-icon iconPositionEnd>chevron_right</mat-icon>
            </button>
            <button [routerLink]="'/dashboard'" mat-button (click)="tourEnd()" *ngIf="!tourService.hasNext(step)">
              {{step.endBtnTitle}}
            </button>
          </div>
        </div>
      </mat-card>
    </ng-template>
  </tour-step-template>
</div>
<ngx-loading-bar color="#ffe239" height="4px" [includeSpinner]="false" ref="http"></ngx-loading-bar>

<!-- Floating Onboarding Checklist -->
<app-floating-checklist *ngIf="!suppressTrialUx"></app-floating-checklist>